import { getTermsOfUseServer } from '@castlery/modules-cms-domain';

export const termsOfUsePreload = () => {
  void getTermsOfUseServer(undefined, {
    revalidate: 60,
  });
};
